module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst headLeft = storage.__('prices.priceTiles.headline')\n%><ol><%\nfor(const [entityKey, entity] of Object.entries(model.entities || {})){\nconst entityAttributes = entity.attributes || {}\nconst entityID = entityAttributes[entity.primaryKey || 'id']\nconst {\npriceID,\nprices,\n} = entityAttributes\nconst {\nvalidFrom,\nvalidTo,\n} = (entityAttributes.priceConfig || {})\nlet head = '', content = ''\nif(validFrom && validTo){\nhead = [\nutils.moment(validFrom).format('DD.MM.YYYY'),\n' - ',\nutils.moment(validTo).subtract(1, 'day').format('DD.MM.YYYY'),\n].join('')\n} else {\nhead = storage.__('prices.asCrew.noPriceConfigAvailable')\n}\nif(priceID) {\ncontent = prices\n} else {\ncontent = storage.__('prices.asCrew.noPriceAvailable')\n}\n%><li data-entity-id=\"<%= entityID %>\"><%\n%><div class=\"head\"><%\n%><div><%= headLeft %></div><%\n%><div><%- head %></div><%\n%></div><%\n%><p><i class=\"fi fi-edit\"></i><%- content %></p><%\n%></li><%\n}\n%></ol>"
  , __filename = "components/templates/crew/profile/priceTiles.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const headLeft = storage.__('prices.priceTiles.headline')

    ; __line = 3
    ; __append("<ol>")
    ; 
for(const [entityKey, entity] of Object.entries(model.entities || {})){
const entityAttributes = entity.attributes || {}
const entityID = entityAttributes[entity.primaryKey || 'id']
const {
priceID,
prices,
} = entityAttributes
const {
validFrom,
validTo,
} = (entityAttributes.priceConfig || {})
let head = '', content = ''
if(validFrom && validTo){
head = [
utils.moment(validFrom).format('DD.MM.YYYY'),
' - ',
utils.moment(validTo).subtract(1, 'day').format('DD.MM.YYYY'),
].join('')
} else {
head = storage.__('prices.asCrew.noPriceConfigAvailable')
}
if(priceID) {
content = prices
} else {
content = storage.__('prices.asCrew.noPriceAvailable')
}

    ; __line = 30
    ; __append("<li data-entity-id=\"")
    ; __append(escapeFn( entityID ))
    ; __append("\">")
    ; 

    ; __line = 31
    ; __append("<div class=\"head\">")
    ; 

    ; __line = 32
    ; __append("<div>")
    ; __append(escapeFn( headLeft ))
    ; __append("</div>")
    ; 

    ; __line = 33
    ; __append("<div>")
    ; __append( head )
    ; __append("</div>")
    ; 

    ; __line = 34
    ; __append("</div>")
    ; 

    ; __line = 35
    ; __append("<p><i class=\"fi fi-edit\"></i>")
    ; __append( content )
    ; __append("</p>")
    ; 

    ; __line = 36
    ; __append("</li>")
    ; 
}

    ; __line = 38
    ; __append("</ol>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/profile/priceTiles.ejs

}